export const PROGRESSION_TABLE_CLASS = 'tw:table-fixed! tw:min-w-4xl tw:mb-0! tw:[&_td]:break-words'

export const PROGRESSION_TABLE_HEAD_CLASS = 'tw:bg-gray-100 '
  + 'tw:[&_th]:font-semibold! tw:[&_th]:text-xs! tw:[&_th]:text-gray-500!'
